import { useSettings } from "@/context/SettingsContext";
import { imgUrl } from "@/lib/api";

export const Logo = ({ size = 44, className = "", testId = "site-logo" }) => {
  const { settings } = useSettings();
  return (
    <img
      src={imgUrl(settings?.logo_url) || "/logo.png"}
      alt="Underdog Podcasts"
      width={size}
      height={size}
      className={`rounded-full object-contain select-none ring-1 ring-white/20 shadow-[0_0_18px_rgba(56,189,248,0.25)] ${className}`}
      style={{ width: size, height: size }}
      draggable={false}
      data-testid={testId}
    />
  );
};
